import { render } from "./IndividualOrientationAssessmentReport.vue?vue&type=template&id=68b8323d&scoped=true"
import script from "./IndividualOrientationAssessmentReport.vue?vue&type=script&lang=js"
export * from "./IndividualOrientationAssessmentReport.vue?vue&type=script&lang=js"

import "./IndividualOrientationAssessmentReport.vue?vue&type=style&index=0&id=68b8323d&scoped=true&lang=css"

import exportComponent from "/var/www/new_dev_tis/frontend/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68b8323d"]])

export default __exports__